import React from 'react';
import { Layout, theme } from 'antd';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useApp } from '../context/AppContext';

const { Content } = Layout;

/**
 * AppLayout wraps authenticated views with Sidebar + Topbar + content area.
 * Uses Ant Design Layout for proper sider integration.
 */
const AppLayout = ({ children }) => {
    const { sidebarOpen } = useApp();
    const { token } = theme.useToken();

    return (
        <Layout style={{ minHeight: 'calc(100vh / var(--app-zoom))' }}>
            <Sidebar />
            <Layout style={{
                marginLeft: sidebarOpen ? 260 : 72,
                transition: 'margin-left 0.2s',
            }}>
                <Topbar />
                <Content style={{
                    padding: 24,
                    // One shell background: the antd layout token (== Layout bodyBg in both themes).
                    background: token.colorBgLayout,
                }}>
                    {children}
                </Content>
            </Layout>
        </Layout>
    );
};

export default AppLayout;
